let Constants = require("@/request/base.default.js");
import router from '@/pages/index/router';

// 调用
// var cookie_value = getCookie(cookie_name);
const getCookie = function (name) {
    let isWx = checkWx();
    if (isWx) {
        return GetQueryValue('sessionid')
    } else {
        var strcookie = document.cookie;//获取cookie字符串
        var arrcookie = strcookie.split("; ");//分割
        //遍历匹配
        for (var i = 0; i < arrcookie.length; i++) {
            var arr = arrcookie[i].split("=");
            if (arr[0] == name) {
                return arr[1];
            }
        }
        return "";
    }
}

// 路由跳转封装
const navigate = (modelName, url = null) => { //控制页面跳转---小程序、公众号、非微信跳转方式 【modelName---vue路由名字】
    let isWx = checkWx();
    // let sessionid = '';
    // if(isWx) {
    //     sessionid = GetQueryValue('sessionid')
    // } else {
    //     sessionid = getCookie(Constants.cookie_key);
    // }
    let str = '';
    if (modelName) {
        // let path = '';
        if (typeof modelName == 'string') {
            str = modelName.replace('/', '')
            // path = modelName
        } else {
            str = modelName.path.replace('/', '') + '?'
            // path = modelName.path
            for (const i in modelName.query) {
                str += i + '=' + modelName.query[i] + '&'
            }
        }
    }
    if (isWx) {//小程序页面
        // if(!GetQueryValue('sessionid')) {
        //     wx.miniProgram.navigateTo({url: '../login/login'})
        //     return false;
        // }
        if (url) {
            if (url.indexOf("?") == -1) {
                url = url + '?miniprogram=1'
            } else {
                url = url + '&miniprogram=1'
            }
            wx.miniProgram.navigateTo({ url: '../detail/detail?url=' + encodeURIComponent(url) })
        } else {
            if (str.indexOf("?") == -1) {
                str = str + '?miniprogram=1'
            } else {
                str = str + '&miniprogram=1'
            }
            wx.miniProgram.navigateTo({ url: '../detail/detail?url=' + Constants.baseURL + '/h5/index/#/' + encodeURIComponent(str) });
            // wx.miniProgram.navigateTo({url: '../detail/detail?url=' + 'http://192.168.0.18:8080/h5/index/#/' + encodeURIComponent(str)});
        }
    } else {
        if (url) {
            if (url.indexOf('?') == -1) {
                window.location.href = url + '?share=0'
            } else {
                window.location.href = url + '&share=0'
            }
        } else {
            router.push(modelName)
        }
    }
}

// 路由跳转封装,非微信跳转为新窗口打开
const navigate2 = (modelName, url = null) => { //控制页面跳转---小程序、公众号、非微信跳转方式 【modelName---vue路由名字】
    let isWx = checkWx();
    // let sessionid = '';
    // if(isWx) {
    //     sessionid = GetQueryValue('sessionid')
    // } else {
    //     sessionid = getCookie(Constants.cookie_key);
    // }
    let str = '';
    if (modelName) {
        // let path = '';
        if (typeof modelName == 'string') {
            str = modelName.replace('/', '')
            // path = modelName
        } else {
            str = modelName.path.replace('/', '') + '?'
            // path = modelName.path
            for (const i in modelName.query) {
                str += i + '=' + modelName.query[i] + '&'
            }
        }
    }
    if (isWx) {//小程序页面
        // if(!GetQueryValue('sessionid')) {
        //     wx.miniProgram.navigateTo({url: '../login/login'})
        //     return false;
        // }
        if (url) {
            if (url.indexOf("?") == -1) {
                url = url + '?miniprogram=1'
            } else {
                url = url + '&miniprogram=1'
            }
            wx.miniProgram.navigateTo({ url: '../detail/detail?url=' + encodeURIComponent(url) })
        } else {
            if (str.indexOf("?") == -1) {
                str = str + '?miniprogram=1'
            } else {
                str = str + '&miniprogram=1'
            }
            wx.miniProgram.navigateTo({ url: '../detail/detail?url=' + Constants.baseURL + '/h5/index/#/' + encodeURIComponent(str) });
            // wx.miniProgram.navigateTo({url: '../detail/detail?url=' + 'http://192.168.0.18:8080/h5/index/#/' + encodeURIComponent(str)});
        }
    } else {
        if (url) {
            if (url.indexOf('?') == -1) {
                window.open(url + '?share=0')
            } else {
                window.open(url + '&share=0')
            }
        } else {
            router.push(modelName)
        }
    }
}

const checkWx = () => {
    var ua = navigator.userAgent.toLowerCase();
    var result = true;
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
        //ios的ua中无miniProgram，但都有MicroMessenger（表示是微信浏览器）
        wx.miniProgram.getEnv((res) => {
            if (res.miniprogram) {
                result = true
            } else {
                result = false
            }
        })
    } else {
        result = false
    }
    return result;
}

// 获取url参数值
function GetQueryValue(val) {
    const w = window.location.hash.indexOf('?');
    const query = window.location.hash.substring(w + 1);
    const vars = query.split('&');
    for (let i = 0; i < vars.length; i++) {
        const pair = vars[i].split('=');
        if (pair[0] == val) { return pair[1]; }
    }
    return (false);
}


export { getCookie, navigate, navigate2, checkWx, GetQueryValue };